<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Search Student
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Enter PRN / First Name / Last Name</b></p>
                    <v-text-field class="padding-bot" outlined dense rounded type="text"
                        v-model="learner"></v-text-field>
                </v-col>


                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot">-</p>
                    <v-btn class="button " @click="fetch" rounded :loading="loader">
                        Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <br>
        <v-card class="box" v-if="this.info.length > 0">
            <v-data-table :headers="headers" :items="info" dense class="elevation-1 mytable">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Student Details
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <br>
                </template>
                <template v-slot:[`item.fee_details`]="{ item }">
                    <v-btn class="btn-css btn"
                        @click="get_learners_fee(item.lid)"><v-icon>mdi-information</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Fee Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense class="elevation-1" fixed-header>
                        <thead>
                            <tr>
                                <th class="" colspan="3" v-for="header in ay_header" :key="header">
                                    <center>{{ header }}</center>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <th v-for="(header,index)  in ay_header.length * 3" :key="index">
                                <span v-if="header%3 == 0">
                                    Total Outstanding
                                </span>
                                <span v-else-if="header%3 == 1">
                                    Paid Outstanding
                                </span>
                                <span v-else>
                                    Balance Outstanding
                                </span>
                            </th>
                            <tr>
                                <td v-for="(s,index) in all_comp" :key="index">
                                    {{s}}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
  data: () => ({
    learner:"",
    loader: false,
    search: "",
      snackbar_msg: "",
    //   extraBreadcrumbItems: [
       

    //   ],
    //   breadcrumbClass: "breadcrumb-style1",
    snackbar: false,
    dialog:false,
    color: "",
    info:[],
    all_comp:[],
    ay_header:[],
    headers: [
        { text: "PRN.", value: "prn_no", sortable: "true" },
        { text: "GR.No.", value: "gr_number", sortable: "true" },
        { text: "Fee Details", value: "fee_details", sortable: "false" },
        { text: "FirstName", value: "firstname" ,sortable: "true"},
        { text: "MiddlenName", value: "middlename", sortable: "true" },
        { text: "LastName", value: "lastname", sortable: "true" },
        { text: "Full Name", value: "fullname",sortable: "true" },
        { text: "Mobile", value: "mobile_no", sortable: "true" },
        { text: "Status", value: "inactive", sortable: "true" },
        { text: "Quota", value: "quota", sortable: "true" },
        { text: "Standard", value: "standard", sortable: "true" },
        { text: "Division", value: "division", sortable: "true" },
        { text: "Rollno", value: "rollno", sortable: "true" },
        { text: "Email", value: "personal_email", sortable: "false" },
        { text: "Aadhaar", value: "aadhar_no", sortable: "false" },
        { text: "PAN", value: "pan_no", sortable: "false" },
        { text: "DOB", value: "date_of_birth", sortable: "false" },
        { text: "SaralId", value: "saral_id", sortable: "false" },
        { text: "Emergency Contact Name", value: "emergency_contact_name", sortable: "false" },
        { text: "Emergency Contact No", value: "emergency_contact_number", sortable: "false" },
    ],
  }),
  methods: {
      get_learners_fee(lid){
          const data={
              lid :lid
          }
        axios
            .post("/RoleManagement/getLearnerFeesDetails",data)
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.all_comp = res.data.all_comp
                    this.ay_header = res.data.ay_header
                    this.dialog = true
                }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                    this.dialog = false
                })
                .finally(() => {
                    // this.dialog = false
                });
      },    
      fetch(){
          if(this.learner=="" || this.learner==null){
              this.showSnackbar("#b71c1c", "Please Enter PRN Or Name Of Student...");
              return
          }
          const data = {
            learner: this.learner,
          }
          this.loader=true
       axios
        .post("/RoleManagement/searchLearner",data)
        .then((res) => {
            if (res.data.flag == "YES") {
                if(res.data.info.length <= 0){
                    this.showSnackbar("#b71c1c", "No Records Found..");
                }
              this.info=res.data.info
              this.loader=false
             
            } else {
                //   window.console.log(res.data.msg);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            }
        })
        .catch((error) => {
            window.console.log(error);
        })
        .finally(() => {});
            },
    showSnackbar(clr, msg) {
    this.snackbar = true;
    this.color = clr;
    this.snackbar_msg = msg;
  }
  },
   
};
</script>
<style scoped>

.mytable /deep/ thead th {
        /* background: #0f2027; 
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); 
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); 
        background-color: #0f2027 !important;
        color: white !important; */
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
       .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    
</style>
